// // RcicCheck.tsx

// import React, { useState } from 'react';
// import Modal from 'react-modal';

// Modal.setAppElement('#root');

// const RcicCheck: React.FC = () => {
//     const [modalIsOpen, setModalIsOpen] = useState(true);

//     const closeModal = () => {
//         setModalIsOpen(false);
//     };

//     // Styles for the modal overlay
//     const overlayCustomStyles = {
//         backgroundColor: 'rgba(75, 85, 99, 0.5)',
//         zIndex: 50,
//     };

//     // Styles for the modal content
//     const contentCustomStyles: React.CSSProperties = {
//         position: 'fixed',
//         top: '50%', // Center vertically
//         left: '50%', // Center horizontally
//         transform: 'translate(-50%, -50%)', // Adjust for centering
//         padding: '1rem',
//         maxHeight: '89vh', // Maximum height set to 80% of the viewport height
//         //maxWidth: '32rem', // Maximum width
//         width: 'calc(100% - 7rem)', // Width is 100% of the viewport width minus some margin
//         overflowY: 'auto', // Enable vertical scrolling
//         background: '#ffffff',
//         borderRadius: '0.5rem',
//         boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.1)',
//         display: 'flex',          // Enable flexbox layout
//         flexDirection: 'column',  // Stack children vertically
//         alignItems: 'center',
//     };


//     return (
//         <>
//             <Modal
//                 isOpen={modalIsOpen}
//                 onRequestClose={closeModal}
//                 style={{ overlay: overlayCustomStyles, content: {} }}
//                 contentLabel="RCIC Status Information"
//             >
//                 <div style={contentCustomStyles}>
//                     <div style={{ textAlign: 'center' }}>
//                         {/* Modal Content */}
//                         <h2>Welcome to FastCheck: RCICs!</h2>
//                         <strong>Only RCICs and RISIAs with an “Active” status on the Public Register can provide immigration advice or services:</strong>
//                         <ul>
//                             <li><strong>Active:</strong> A licensee in good standing with the College authorized to provide immigration services to clients.</li>
//                             <li><strong>Active – Practice Restricted:</strong> A licensee who has had their practice restricted as part of an interim order or disciplinary finding made by the Discipline Committee. The specific restriction will be listed beside the status.</li>
//                         </ul>
//                         <br />
//                         <strong>Licensees with the statuses listed below CANNOT provide services:</strong>
//                         <br />
//                         <ul>
//                             <li><strong>Leave of Absence:</strong> A licensee who has taken leave from the profession for a specific period and has agreed not to provide immigration services until they return.</li>
//                             <li><strong>Resigned:</strong> A licensee who has notified the College that they no longer wish to practise and has officially resigned their licence.</li>
//                             <li><strong>Resigned – Called to the Bar:</strong> An RCIC who has resigned from the College while in good standing after becoming a licensed member of a Canadian provincial law society (a lawyer).</li>
//                             <li><strong>Resigned – While Under Investigation:</strong> An RCIC who has resigned their licence with the College while under disciplinary investigation.</li>
//                             <li><strong>Administrative Suspension:</strong> A licensee who has had their licence suspended because they failed to pay fees, complete CPD hours as required, or failed to meet another administrative obligation required to maintain their licence.</li>
//                             <li><strong>Administrative Revocation:</strong> A licensee who had their licence revoked for failing to complete a required action within 90 days of an administrative suspension.</li>
//                             <li><strong>Disciplinary Suspension:</strong> A licensee who has had their licence suspended as part of an interim order or disciplinary finding made by the Discipline Committee.</li>
//                             <li><strong>Disciplinary Revocation:</strong> A licensee who has had their licence revoked as part of an interim order or disciplinary finding made by the Discipline Committee.</li>
//                             <li><strong>Deceased:</strong> A licensee whose death has been reported to the Registrar.</li>
//                         </ul>
//                         <br />
//                         <p><em>*Suspension or Revocation may happen because of a failure to: Pay fees, complete the PME course, fulfill licensee admissions condition, meet CPD requirements, pay fines or penalties, complete Quality Management Program requirements, respond to the College, or comply with a discipline order.</em></p>
//                     </div>
//                     <button
//                         onClick={closeModal}
//                         style={{
//                             backgroundColor: '#3b82f6',
//                             color: 'white',
//                             fontWeight: 'bold',
//                             padding: '0.5rem 1rem',
//                             borderRadius: '0.375rem',
//                             border: 'none',
//                             cursor: 'pointer',
//                             display: 'flex',
//                             marginTop: '1rem',
//                         }}
//                     >
//                         Enter Site
//                     </button>
//                 </div>
//             </Modal>
//             {!modalIsOpen && (
//     <a
//         href="https://register.college-ic.ca/Public-Register-EN/RCIC_Search.aspx"
//         target="_blank"
//         rel="noopener noreferrer"
//         style={{
//             display: 'inline-block',
//             backgroundColor: '#3b82f6',
//             color: 'white',
//             fontWeight: 'bold',
//             padding: '0.5rem 1rem',
//             borderRadius: '0.375rem',
//             textDecoration: 'none',
//             marginTop: '1rem',
//         }}
//     >
//         Visit FastCheck: RCICs
//     </a>
// )}

//         </>
//     );
// }
// export default RcicCheck;

import React from 'react';

const RcicCheck: React.FC = () => {
    return (
        <div style={{ textAlign: 'center', marginTop: '20px' }}>
            <a
                href="https://register.college-ic.ca/Public-Register-EN/RCIC_Search.aspx"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    display: 'inline-block',
                    backgroundColor: '#3b82f6',
                    color: 'white',
                    fontWeight: 'bold',
                    padding: '0.5rem 1rem',
                    borderRadius: '0.375rem',
                    textDecoration: 'none',
                    marginTop: '1rem',
                }}
            >
                Visit FastCheck: RCICs
            </a>
        </div>
    );
};

export default RcicCheck;
